import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

type Props = {
    className?: string;
};

export const RowDivider = ({ className }: Props) => {
    return <hr className={cn('mb-md mt-0 w-full border-b-0 border-t border-border-secondary', className)} />;
};
